'use strict';
import isEqualWith from 'lodash/isEqualWith';
import isFunction from 'lodash/isFunction';


/**
 * @typedef {Object} RoleData
 * @property {?Role} orgRole
 * @property {?Role} [projectRole]
 * @property {?Boolean} [projectIsPrivate]
 * @property {?Boolean} [projectIsLocked]
 * @property {?Boolean} [assetProjectIsLocked]
 * @property {?Role} [taskRole]
 * @property {?Boolean} [taskIsPrivate]
 * @property {?Boolean} [taskIsLocked]
 * @property {?Role} [assetTaskRole]
 * @property {?Boolean} [assetTaskIsPrivate]
 * @property {?Boolean} [assetTaskIsLocked]
 */

/**
 * Organization part of RoleData
 * @param {Role} role
 */
export function orgRoleData(role) {
  return {
    orgRole: role,
  };
}

/**
 * Project part of RoleData
 * @param {Role} role
 * @param {Boolean} isPrivate
 * @param {Boolean} projectIsLocked The project status is currently either complete or cancelled
 */
export function projectRoleData(role, isPrivate, projectIsLocked) {
  return {
    projectRole: role,
    projectIsPrivate: isPrivate,
    projectIsLocked,
  };
}

/**
 * AssetProject part of RoleData
 * Currently, role and private are not implemented.
 * @param {Role} role
 * @param {Boolean} isPrivate
 * @param {Boolean} assetProjectIsLocked The project status is currently either complete or cancelled
 */
export function assetProjectRoleData(role, isPrivate, assetProjectIsLocked) {
  return {
    assetProjectIsLocked,
  };
}

/**
 * Task part of RoleData
 * @param {Role} role
 * @param {Boolean} isPrivate
 * @param {Boolean} taskIsLocked The task status is currently either approved or cancelled
 */
export function taskRoleData(role, isPrivate, taskIsLocked) {
  return {
    taskRole: role,
    taskIsPrivate: isPrivate,
    taskIsLocked,
  };
}

/**
 * AssetTask part of RoleData
 * @param {Role} role
 * @param {Boolean} isPrivate
 * @param {Boolean} assetTaskIsLocked The task status is currently either approved or cancelled
 */
export function assetTaskRoleData(role, isPrivate, assetTaskIsLocked) {
  return {
    assetTaskRole: role,
    assetTaskIsPrivate: isPrivate,
    assetTaskIsLocked,
  };
}

export function isCompositeRoleDataChange(a, b) {
  return isEqualWith(a, b, compareRoleData);
}

function compareRoleData(a, b) {
  // We can ignore the permissions function in the Role class because we are checking the only object it references.
  if (isFunction(a) && isFunction(b)) {
    return true;
  } else {
    return void 0;
  }
}



// WEBPACK FOOTER //
// ./src/js/auth/services/RoleData.js